import React from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import "../../styles/SideBarStyles.css";

const Sidebar = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const logout = () => {
    localStorage.removeItem("adminToken");
    navigate("/admin/login");
  };

  return (
    <div className="sidebar-container">
      <a
        href="/admin/dashboard"
        className="sidebar-title text-decoration-none"
      >
        Cantabria S.A.S
      </a>
      <hr />
      <ul className="nav flex-column mb-auto">
        <li>
          <Link
            to="/admin/dashboard"
            className={`nav-link ${
              location.pathname === "/admin/dashboard" ? "active" : ""
            }`}
          >
            Menú Principal
          </Link>
        </li>
        <li>
          <Link
            to="/admin/properties"
            className={`nav-link ${
              location.pathname === "/admin/properties" ? "active" : ""
            }`}
          >
            Propiedades
          </Link>
        </li>
        <li>
          <Link
            to="/admin/projects"
            className={`nav-link ${
              location.pathname === "/admin/projects" ? "active" : ""
            }`}
          >
            Proyectos
          </Link>
        </li>
      </ul>
      <hr className="divider-below-options" />
      <button className="logout-button" onClick={logout}>
        Cerrar Sesión
      </button>
    </div>
  );
};

export default Sidebar;
